import { render } from "./UVIndexView.vue?vue&type=template&id=6e7df880&scoped=true"
import script from "./UVIndexView.vue?vue&type=script&lang=js"
export * from "./UVIndexView.vue?vue&type=script&lang=js"

import "./UVIndexView.vue?vue&type=style&index=0&id=6e7df880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7df880"]])

export default __exports__